import { RequestInterface } from 'application/connectors/cms/_api';
import { getPageContentFromCDA, getPageContentFromCms } from 'application/connectors/cms/pageContentConnector';

export const getPageContent = async ({ url, pageContext, siteId }: RequestInterface & { siteId?: string }): Promise<Content.PageContent> => {
	if (!siteId) return await getPageContentFromCms(url, pageContext);
	if (siteId) {
		return await getPageContentFromCDA(url, pageContext, siteId);
	}
};
